import React from "react";

import ApplicationListActions from "../actions";

import styles from "../applicationList.module.scss";

const applicationListActionsColumn = ({
	showInlineEditButton,
	showRemoveButton,
}: any) => ({
	Header: "Actions",
	accessor: "",
	disableSortBy: true,
	classNameCell: `${styles.actionsCell}`,
	classNameHeader: `${styles.actionsCellHeader}`,
	Cell: ({ row, setRowState }) => (
		<ApplicationListActions
			row={row}
			setRowState={setRowState}
			showInlineEditButton={showInlineEditButton}
			showRemoveButton={showRemoveButton}
		/>
	),
});

export default applicationListActionsColumn;
